module.exports = __webpack_public_path__ + "static/img/m2222.db3fb85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/m2222.png
// module id = UuE2
// module chunks = 1